import { render, staticRenderFns } from "./BazarCompra.vue?vue&type=template&id=053134c2&"
import script from "./BazarCompra.vue?vue&type=script&lang=js&"
export * from "./BazarCompra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports